export default {
    routerName: '用户管理',
    user: {
        searchName: '检索条件',
        deptName: '部门名',
        type: '用户类型',
        loginName: '账号',
        name: '姓名',
        status: '状态',
        open: '启用',
        close: '停用',
        systemUser: '系统用户',
        normalUser: '普通用户',
        members: '会员用户',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
    },
    sortButton: {
        deptName: '部门名',
        name: '姓名',
        type: '用户类型',
        createTime: '创建时间',
    },
    table: {
        id: 'ID',
        deptName: '部门名',
        loginName: '登录名',
        name: '姓名',
        mobile: '电话',
        createBy: '创建者',
        createTime: '创建时间',
        type: '用户类型',
        status: '状态',
    },
};
